<template>
  <section class="content">
    <div class="container-fluid">
      <div class="block-header">
        <h2>Galeri</h2>
      </div>
      <div class="row clearfix">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="card">
            <div class="header">
              <h2>{{ id_galeri != null ? 'Edit' : 'Tambah' }} Video</h2>
            </div>
            <div class="body">
              <form class="form-horizontal" @submit.prevent="save">
                <div class="row clearfix">
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                    <label for="file">Link</label>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                    <div class="form-group">
                      <form-line id="file" type="text" v-model="data.file"></form-line>
                    </div>
                  </div>
                </div>

                <div class="row clearfix">
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                    <label for="upload">Foto/Video</label>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                    <div class="form-group">
                      <input
                        type="file"
                        id="upload"
                        class="form-control"
                        accept="video/*,image/*"
                        @change="handleFileUpload"
                      />
                      <div v-if="uploadProgress > 0">Progress: {{ uploadProgress }}%</div>
                    </div>
                  </div>
                </div>

                <div class="row clearfix">
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                    <label for="deskripsi">Deskripsi</label>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                    <div class="form-group">
                      <form-line id="deskripsi" type="text" v-model="data.deskripsi"></form-line>
                    </div>
                  </div>
                </div>

                <div class="row clearfix">
                  <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                    <button :disabled="isLoading" v-if="id_galeri != null" @click="update" type="button" class="btn btn-warning">
                      <span v-if="!isLoading"><i class="material-icons">save</i> Edit</span>
                      <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                    </button>
                    <button :disabled="isLoading" v-else @click="save" type="button" class="btn btn-primary">
                      <span v-if="!isLoading"><i class="material-icons">save</i> Simpan</span>
                      <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                    </button>
                    <button @click="$router.go(-1)" type="button" class="btn btn-danger">
                      <i class="material-icons">cancel</i> Batal
                    </button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import FormLine from '@/components/FormLine.vue';
import api from '@/helper/api';

export default {
  name: 'FormGaleri',
  components: { FormLine },
  data() {
    return {
      data: {
        file: '',
        deskripsi: '',
        tipe: 2
      },
      id_galeri: '',
      isLoading: false,
      uploadProgress: 0
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      console.log('File dipilih:', file.name, file.type, file.size);

      const formData = new FormData();
      formData.append('file', file);

      const token = localStorage.getItem('_token');

      api.post('/upload_galeri', formData, {
        headers: {
          Authorization: 'Bearer ' + token
          // Jangan set Content-Type manual agar browser yang handle boundary
        },
        timeout: 0, // No timeout untuk file besar
        onUploadProgress: (e) => {
          if (e.lengthComputable) {
            this.uploadProgress = Math.round((e.loaded * 100) / e.total);
          }
        }
      }).then((response) => {
        console.log('Respon upload:', response);

        var uploaded = '';
        if (response.data && response.data.object && response.data.object.id) {
          uploaded = response.data.object.id;
        } else if (response.data && response.data.file) {
          uploaded = response.data.file;
        }

        if (uploaded) {
          this.data.file = uploaded;
          this.$toastr.s('Upload berhasil');
        } else {
          this.$toastr.e('Upload berhasil tapi file tidak dikenali');
        }

      }).catch((err) => {
        console.error('Upload error:', err);
        this.$toastr.e('Upload gagal: ' + (err.response.data.message || 'Terjadi kesalahan'));
      });
    },

    save() {
      this.isLoading = true;
      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');

      api.post('/galeri', this.data).then((res) => {
        if (res.data.code === 200) {
          this.$toastr.s('Tambah data berhasil');
          this.$router.replace('/main/informasi/galeri');
        } else {
          this.$toastr.e(res.data.message || 'Tambah data gagal');
        }
        this.isLoading = false;
      }).catch((err) => {
        this.isLoading = false;
        const msg = (err.response && err.response.data && err.response.data.message) || 'Terjadi kesalahan';
        this.$toastr.e(msg);
      });
    },

    update() {
      this.isLoading = true;
      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');

      api.post('/galeri/' + this.id_galeri, this.data).then((res) => {
        if (res.data.code === 200) {
          this.$toastr.s('Ubah data berhasil');
          this.$router.replace('/main/informasi/galeri');
        }
        this.isLoading = false;
      }).catch((err) => {
        this.isLoading = false;
        const msg = (err.response && err.response.data && err.response.data.message) || 'Terjadi kesalahan';
        this.$toastr.e(msg);
      });
    },

    getDetail() {
      const id = this.id_galeri;
      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      api.get('/galeri/' + id).then((res) => {
        this.data = res.data;
      }).catch(() => {
        this.$toastr.e('Gagal memuat data');
      });
    }
  },
  mounted() {
    this.id_galeri = this.$route.params.id;
    if (this.id_galeri) {
      this.getDetail();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/Informasi/FormGaleri.vue